<ion-header>
    <ion-toolbar>
        <ion-title color="primary" class="text-center">{{ 'userIdle.title' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding ion-text-center">
    <ion-text class="text-xl">{{ 'userIdle.youWillBeLoggedOutSoon' | translate }}</ion-text>
    <ion-text class="py-6 text-5xl block" color="primary">{{ getTimeLeft((secondsTillTimeout$ | async) ?? 0) }}</ion-text>
</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-buttons class="flex gap-4 px-4 py-4">
            <ion-button (click)="stay()" class="flex-1" color="primary" fill="solid">
                <ion-text>{{ 'userIdle.stay' | translate }}</ion-text>
            </ion-button>
            <ion-button (click)="logout()" class="flex-1" color="primary" fill="outline">
                <ion-text>{{ 'userIdle.logout' | translate }}</ion-text>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
